import { Doc } from "tiptap";

export default class SingleTextDoc extends Doc {
	get name() {
		return "doc";
	}

	get schema() {
		return {
			content: "text*"
		};
	}
}
